import React, { useEffect } from "react";
import Head from "next/head";
import Script from "next/script";
import s from "./HomeOwner_Sidebar.module.scss";
import $ from 'jquery';

const HomeOwners_Sidebar = () => {

  useEffect(() => {
    // console.log("LOADING ...");

	if (window.location.pathname.indexOf("/fr/") > -1) {

		$("h2:contains(TECHNOLOGIE DE POINTE)").attr("id", "hvac_tech");

		$("a.button:contains(TECHNOLOGIE)").attr("href", "#hvac_tech");

		$("a:contains(INSTALLATION SANS CONDUIT)").attr("href", "/fr/hvac/home-owners/ductless-solutions");
		$("a:contains(INSTALLATION GAINABLE)").attr("href", "/fr/hvac/home-owners/ducted-solutions");
		$("a:contains(AVANTAGES & TECHNOLOGIE)").attr("href", "/fr/hvac/home-owners/benefits-and-technology");

		$("a:contains(ZONES CHAUDES ET FROIDES)").attr("href", "/fr/hvac/home-owners/hot-and-cold-spots");
		$("a:contains(FACTURE D')").attr("href", "/fr/hvac/home-owners/cost-efficiency");
		$("a:contains(TROP BRUYANT)").attr("href", "/fr/hvac/home-owners/whisper-quiet");
		$("a:contains(MAUVAISE QUALIT)").attr("href", "/fr/hvac/home-owners/air-quality");
		$("a:contains(VARIATIONS DE TEMP)").attr("href", "/fr/hvac/home-owners/consistent-temps");
		$("a:contains(EMPREINTE DE CARBONE)").attr("href", "/fr/hvac/home-owners/carbon-footprint");

		$("a:contains(LES D'UNIT)").attr("href", "#indoor_fr");

		$("a:contains(CHARGEZ LA BROCHURE)").attr("href", "https://cdn.agilitycms.com/mesca/productdownloads/mem-201911v1-f-home-owners-brochure_fr.pdf");
		$("a:contains(claration de garanti)").attr("href", "https://cdn.agilitycms.com/mesca/pdfs-hvac/mesca_m-and-p-series-warranty-2019_fr-v2.pdf");

		$("a[href='/en/home-owners/whole-home-solutions']").attr("href", "/fr/hvac/home-owners/whole-home-solutions");
		$("a[href='/en/home-owners/multi-zone-systems']").attr("href", "/fr/hvac/home-owners/multi-zone-systems");
		$("a[href='/en/home-owners/single-zone-systems']").attr("href", "/fr/hvac/home-owners/single-zone-systems");

		$("a:contains(TROUVEZ UN CONCESSIONNAIRE PR)").attr("href", "/fr/hvac/where-to-buy");

		$("a:contains(Enregistrement en ligne)").attr("href", "https://mitsubishielectric.ca/fr/hvac/MEQ_Warranty_Registration");

		$("p a:contains(Home owners)").html("Propr&#xE9;taires de maisons");

		$("a[href='#']:contains(ici)").attr("href", "https://cdn.agilitycms.com/mesca/productdownloads/mem-201911v1-f-home-owners-brochure_fr.pdf");


	} else {

		$("a[href='#']:contains(here)").attr("href", "https://cdn.agilitycms.com/mesca/pdfs-hvac/mesca_m-and-p-series-warranty-2019_en.pdf");

		$("h2:contains(ADVANCED TECHNOLOGY)").attr("id", "hvac_tech");
		$("a.button:contains(TECHNOLOGY)").attr("href", "#hvac_tech");

		$("a:contains(INDOOR UNIT STYLES)").attr("href", "#indoor_en");
		$("a:contains(DUCTLESS PRODUCTS)").attr("href", "/en/hvac/home-owners/ductless-solutions");
		$("a:contains(DUCTED PRODUCTS)").attr("href", "/en/hvac/home-owners/ducted-solutions");
		$("a:contains(BENEFITS & TECHNOLOGY)").attr("href", "/en/hvac/home-owners/benefits-and-technology");
		$("a:contains(HOT & COLD SPOTS)").attr("href", "/en/hvac/home-owners/hot-and-cold-spots");
		$("a:contains(COSTLY ENERGY BILL)").attr("href", "/en/hvac/home-owners/cost-efficiency");
		$("a:contains(TOO LOUD)").attr("href", "/en/hvac/home-owners/whisper-quiet");
		$("a:contains(POOR AIR QUALITY)").attr("href", "/en/hvac/home-owners/air-quality");
		$("a:contains(INCONSISTENT TEMPERATURES)").attr("href", "/en/hvac/home-owners/consistent-temps");
		$("a:contains(CARBON FOOTPRINT)").attr("href", "/en/hvac/home-owners/carbon-footprint");
		$("a:contains(WARRANTY STATEMENT PDF)").attr("href", "https://cdn.agilitycms.com/mesca/pdfs-hvac/mesca_m-and-p-series-warranty-2019_en.pdf");
		$("a:contains(BROCHURE DOWNLOAD)").attr("href", "https://cdn.agilitycms.com/mesca/productdownloads/mem-201911v1-e-home-owners-brochure_en.pdf");
		$("a:contains(ONLINE REGISTRATION)").attr("href", "https://mitsubishielectric.ca/en/hvac/MEQ_Warranty_Registration");

		$("a[href='/en/home-owners/whole-home-solutions']").attr("href", "/en/hvac/home-owners/whole-home-solutions");
		$("a[href='/en/home-owners/multi-zone-systems']").attr("href", "/en/hvac/home-owners/multi-zone-systems");
		$("a[href='/en/home-owners/single-zone-systems']").attr("href", "/en/hvac/home-owners/single-zone-systems");

		$("a:contains(FIND A DEALER NEAR YOU)").attr("href", "/en/hvac/where-to-buy");
	}

	if (window.location.pathname.indexOf("/fr/") > -1) {

		$("#sidebar").find("p").remove();
		$("#sidebar").prepend($("#sidebar_fr").html());
		$(".dealerbutton").html("TROUVEZ UN CONCESSIONNAIRE PR&#xC8;S DE CHEZ VOUS");

		$("#indoor_en").remove();

		$('h3:contains(Electric)').html("&#xC9;lectrique");
		$('h3:contains(Natural Gas)').html("Gaz naturel");
		$('h3:contains(Oil, Propane or Other)').html("Huile / propane / autre");

		$('a:contains(WHOLE-HOME)').html("MAISON ENTI&#xC8;RE");
		$('a:contains(MORE THAN ONE ROOM)').html("PLUS D&#x27;UNE PI&#xC8;CE");
		$('a:contains(ONE ROOM ONLY)').html("UNE SEULE PI&#xC8;CE");

		$("small:contains(et moins selon les conditions climatiques.)").text($("small:contains(et moins selon les conditions climatiques.)").text().replace(" moins ", " plus "));

		$("img[alt='https://www.youtube.com/embed/UafTs9pF9zE']").attr("alt", "https://www.youtube.com/embed/dJS_qVmzoXQ");
		$("img[alt='https://www.youtube.com/embed/Zo1pEqqpA90']").attr("alt", "https://www.youtube.com/embed/TCLjDJwx84c");
		$("img[alt='https://www.youtube.com/embed/HrDWNqrcYlw']").attr("alt", "https://www.youtube.com/embed/LYF8me4f0Sc");
		$("img[alt='https://www.youtube.com/embed/62ymyjXPGSc']").attr("alt", "https://www.youtube.com/embed/T1KIHVt_3_8");
		$("img[alt='https://www.youtube.com/embed/Q_72AAJNuQo']").attr("alt", "https://www.youtube.com/embed/RX8-ob_3ZTg");
		$("img[alt='https://www.youtube.com/embed/9605BmDPpJk']").attr("alt", "https://www.youtube.com/embed/OkWzFAMOJSs");

		if (window.location.pathname.indexOf("single-zone-systems") > -1) {
			var text = $("#ck_indoor_multi_bx p").text().replace("PVA et ", "");
			$("#ck_indoor_multi_bx p").text(text);
		}

		var html = '<div style=" width: 500px; " class="featherlight-inner">  <h2 class="rx16" style=" margin: 0; margin-bottom: 20px; ">RESTONS EN CONTACT</h2>    <div class="row">  <div class="column column-top column-xs-3"><div style="padding-bottom:100%;position:relative"><img src="https://origin.agilitycms.com/mesca/aug2020/photo/news-news.jpg?w=320&amp;h=200&amp;c=2&amp;q=60&amp;dt=20200928153316" caption="false" alt="" style="height: 100% !important; width: 100% !important; object-fit: cover; position: absolute;" class="video"></div> </div><div class="column column-middle column-xs-9"> <p>Nous sommes fiers de figurer parmi les meilleurs fabricants de syst&#xE8;mes de chauffage et de climatisation au monde. Notre objectif est de vous procurer un confort personnalis&#xE9; peu &#xE9;nergivore et respectueux de l&#x27;environnement. Inscrivez-vous d&#xE8;s aujourd&#x27;hui pour recevoir des mises &#xE0; jour occasionnelles sur nos produits, ainsi que des conseils et des offres, et commencez &#xE0; profiter d&#x2019;un confort r&#xE9;sidentiel sans compromis, &#xE0; la mani&#xE8;re de Mitsubishi Electric.</p> </div>  </div><div class="" style=" padding: 20px; background-color: #333; color: white; margin-top: 20px; "><div class="row">  <div class="column column-xs-6" style=" ">  <h4 style="margin-top: 0;">Pr&#xE9;nom </h4>  <input type="text" style=" margin: 0; /* padding: 0; */ margin-top: 5px; border: 0; width: 100%; ">   </div> <div class="column column-xs-6">  <h4 style="margin-top: 0;">Nom de famille  </h4>  <input type="text" style=" margin: 0; /* padding: 0; */ margin-top: 5px; border: 0; width: 100%; ">   </div>  <div class="column column-xs-6" style=" margin-top: 10px; ">  <h4 style="margin-top: 0;">Adresse courriel  </h4>  <input type="text" style=" margin: 0; /* padding: 0; */ margin-top: 5px; border: 0; width: 100%; ">   </div><div class="column column-xs-6" style=" margin-top: 20px; text-align: right; ">  <a class="button" href="#" target="_self" rel="noopener" style="margin-bottom: 5px;padding-top: 5px;padding-bottom: 5px;">SOUMETTRE</a>   </div>  </div>     </div> <p style=" margin: 0; margin-top: 20px; line-height: 1.2; "><small>Mitsubishi Electric Sales Canada Inc. respecte votre vie priv&#xE9;e. Les informations que vous nous fournissez sont r&#xE9;gies par notre politique de confidentialit&#xE9;. En soumettant cette demande, vous acceptez ces conditions.</small></p></div>';

	} else {
		$("#indoor_fr").remove();
		
		if (window.location.pathname.indexOf("single-zone-systems") > -1) {
			var text = $("#ck_indoor_multi_bx p").text().replace("PVA and ", "");
			$("#ck_indoor_multi_bx p").text(text);
		}
		var html = '<div style=" width: 500px; ">  <h2 class="rx16" style=" margin: 0; margin-bottom: 20px; ">LET&rsquo;S KEEP IN TOUCH</h2>    <div class="row">  <div class="column column-top column-xs-3"><div style="padding-bottom:100%;position:relative"><img src="https://origin.agilitycms.com/mesca/aug2020/photo/news-news.jpg?w=320&amp;h=200&amp;c=2&amp;q=60&amp;dt=20200928153316" caption="false" alt="" style="height: 100% !important; width: 100% !important; object-fit: cover; position: absolute;" class="video"></div> </div><div class="column column-middle column-xs-9"> <p>We are proud to be among the top manufacturers of heating and cooling systems in the world. Our goal is to bring you personalized comfort in an energy-efficient, environmentally friendly fashion. Sign up for occasional product updates, tips, and offers today and start experiencing home comfort without compromise, the Mitsubishi Electric way.</p> </div>  </div><div class="" style=" padding: 20px; background-color: #333; color: white; margin-top: 20px; "><div class="row">  <div class="column column-xs-6" style=" ">  <h4 style="margin-top: 0;">First Name</h4>  <input type="text" style=" margin: 0; /* padding: 0; */ margin-top: 5px; border: 0; width: 100%; ">   </div> <div class="column column-xs-6">  <h4 style="margin-top: 0;">Last Name</h4>  <input type="text" style=" margin: 0; /* padding: 0; */ margin-top: 5px; border: 0; width: 100%; ">   </div>  <div class="column column-xs-6" style=" margin-top: 10px; ">  <h4 style="margin-top: 0;">Email Address</h4>  <input type="text" style=" margin: 0; /* padding: 0; */ margin-top: 5px; border: 0; width: 100%; ">   </div><div class="column column-xs-6" style=" margin-top: 20px; text-align: right; ">  <a class="button" href="#" target="_self" rel="noopener" style="margin-bottom: 5px;padding-top: 5px;padding-bottom: 5px;">SUBMIT</a>   </div>  </div>     </div> <p style=" margin: 0; margin-top: 20px; line-height: 1.2; "><small>Mitsubishi Electric Sales Canada Inc. respects your privacy. The information you provide to us is governed by our Privacy Policy. By submitting this request, you agree to these conditions.</small></p></div>';
	}

	// console.log("LOADING ... 2");

	$(".hvac_keepintouch").each(function(i,o){
		$(this).parent().remove();
		$(this).wrap("<a class='gallery' key='kit' style='position:relative; display:block;' href='#'	data-featherlight='"+html+"' data-featherlight-type='html'>");
	});

	$('h2:contains("FACTURE D")').css("letter-spacing", "-0.5px");
	$('h4:contains(VCSi)').each(function(){
		var text = $(this).html();
		text = text.replace("VCSi", "VCS<span style='text-transform:lowercase;'>i</span>");
		$(this).html(text);
	});

	$('p:contains(50 %)').each(function(){
		var text = $(this).html();
		text = text.replace("50 %", "<span style='white-space:nowrap;'>50 %</span>");
		$(this).html(text);
	});

	$('p:contains(-30  ̊C)').each(function(){
		var text = $(this).html();
		text = text.replace("-30  ̊C", "<span style='white-space:nowrap;'>-30  ̊C</span>");
		$(this).html(text);
	});

	$('h4:contains(H2i)').each(function(){
		var text = $(this).html();
		text = text.replace("H2i", "H2<span style='text-transform:lowercase;'>i</span>");
		$(this).html(text);
	});		

	$('h4:contains(i-See)').each(function(){
		var text = $(this).html();
		text = text.replace("i-See", "<span style='text-transform:lowercase;'>i</span>-See");
		$(this).html(text);
	});		

	$('h4:contains(DRVi)').each(function(){
		var text = $(this).html();
		text = text.replace("DRVi", "DRV<span style='text-transform:lowercase;'>i</span>");
		$(this).html(text);
	});		


	$("#sidebar").after("<div class='row'><div class='column column-lg-9' id='body_left'></div><div class='column column-lg-3' id='body_right'></div></div>");

	$("#sidebar").prevAll().not(":first").each(function(i,o){
		var element = $(this);
		element.find(".column-xs-3").each(function(){

			if ($(this).find("img[src*='icon']").length == 0 && $(this).closest(".homeowners_text").length == 0) {
				$(this).addClass("column-middle");
			}
		});

		element.find(".column-xs-9").each(function(){
			if ($(this).closest(".homeowners_text").length == 0) {
				$(this).addClass("column-middle");
			}
		});			
		
		element.find(".column-xs-8").addClass("column-middle");
		element.find(".column-xs-1").addClass("column-middle");

		element.find(".column-xs-6").removeClass("column-xs-6").addClass("column-lg-6");
		element.find(".column-xs-4").removeClass("column-xs-4").addClass("column-lg-4 column-md-6 column-xs-12");
		element.find(".column-sm-4").removeClass("column-sm-4").addClass("column-lg-4 column-md-6 column-xs-12");
		// $(this).find(".column-xs-3").removeClass("column-xs-3").addClass("column-lg-3 column-md-4 column-xs-12");
		// $(this).find(".column-xs-9").removeClass("column-xs-9").addClass("column-lg-9 column-md-8 column-xs-12");
      	$("#body_left").prepend(element);

    });

	$("h2.rx16").each(function(){
		var text = $(this).text();
		text = text.replace("®", "<sup>&reg;</sup>");
		$(this).html(text);
	});

	$("h4").each(function(){
		var text = $(this).text().trim().toUpperCase();
		if (text == "SMART CONTROL") {

			$(this).text("Remote Control Options");
		}
	});

    $("#body_right").append($("#sidebar"));

	var clone = $("header a[href='/home']:first").parent().clone();
	clone.find("a").css("color", "red");
	clone.find("a").attr("href", "#");
	clone.find("a").text("Rebates and Offers");
	clone.addClass("mobile_only");
	$("header a[href='/home']:first").closest("ul").prepend(clone);

	var clone = $("header a[href='/home']:first").parent().clone();
	clone.find("a").css("color", "red");
	clone.find("a").attr("href", "#");
	clone.find("a").text("Find a Dealer");
	clone.addClass("mobile_only");
	$("header a[href='/home']:first").closest("ul").prepend(clone);

	// console.log("LOADING ... 3");


	if (window.location.pathname.indexOf("/hvac/home-owners/articles") > -1) {
		
		$("#body_left img[style='width: 100%;']").first().each(function(){

			var url = $(this).attr("src");
			url += "?w=640&h=320&c=3";
			$(this).attr("src", url);

		});			

		$("#body_left .column-middle").removeClass("column-middle");

		return false;
	}


	// $("a.gallery[key='1']").attr("data-featherlight")
	// console.log("LOADING ... 4");

	$(document).on("click", ".modal_left", function(){

		var attr = $(this).closest(".lightbox_content").attr("key");
		var keyArray = attr.split(":");
		var prefix = keyArray[0];
		var key = parseInt(keyArray[1]);
		var check = prefix + ":" + (key-1);

		if ($("a.gallery[key='"+check+"']").length == 0) {

			var check = $("a.gallery[key^='"+prefix+":']:last").attr("key");
			var content = $("a.gallery[key='"+check+"']").attr("data-featherlight");

		} else {
			var content = $("a.gallery[key='"+check+"']").attr("data-featherlight");
		}

		$(".featherlight-content>*:not(.featherlight-close)").remove();
		$(".featherlight-content").append(content);

	});

	$(document).on("click", ".modal_right", function(){
	
		var attr = $(this).closest(".lightbox_content").attr("key");
		var keyArray = attr.split(":");
		var prefix = keyArray[0];
		var key = parseInt(keyArray[1]);

		var check = prefix + ":" + (key+1);

		if ($("a.gallery[key='"+check+"']").length == 0) {

			var check = $("a.gallery[key^='"+prefix+":']:first").attr("key");
			var content = $("a.gallery[key='"+check+"']").attr("data-featherlight");

		} else {
			var content = $("a.gallery[key='"+check+"']").attr("data-featherlight");
		}

		$(".featherlight-content>*:not(.featherlight-close)").remove();
		$(".featherlight-content").append(content);

	});

	$( ".homeowners_highlightitem" ).wrapAll( "<div class='collection' />");

	$("#body_left .column-xs-3:visible img[src='https://cdn.agilitycms.com/mesca/aug2020/icons/mesca-website_icons_r4_legacy-8-copy.png']:not([alt])").each(function(i,o){

		$(this).attr("src", "https://origin.agilitycms.com/mesca/Attachments/NewItems/remote-control-accessories-image.png");


	});

	// console.log("LOADING ... 5");

	$("#body_left .column-xs-3:visible img:not([src*='dealer']):not([src*='icon'])").each(function(i,o){

		if ($(this).closest(".homeowners_text").length == 0) {

			var i = "";

			if ($(this).closest(".collection").length > 0) {

				i += $(this).closest(".collection").index(".collection");
				i += ":";
				i += $(this).closest(".collection").find(".column-xs-3 img").index($(this));

			} else {

				i += $(this).closest(".row").index(".row");
				i += ":";
				i += $(this).closest(".row").find(".column-xs-3 img").index($(this));

			}

			// console.log(i);

			var html = $(this).closest(".column").next(".column").html();
			var html = html.replace(/'/g, "&rsquo;");


			$(this).addClass("modal");

			if ($(this).attr("src").indexOf("indoor_") > -1) {

				html = "<div style=\"margin-bottom:20px; height:400px; background-position:center; background-repeat:no-repeat; background-size:contain; background-image:url("+$(this).attr("src")+")\"></div>"+"<div class=\"lightbox_content\" key=\""+i+"\"><div>"+html+"</div><div><a class=\"modal_left\"><i class=\"fa fa-caret-left fa-3x\"></i></a><a class=\"modal_right\"><i class=\"fa fa-3x fa-caret-right\"></i></a></div></div>";

			} else {

				html = "<div style=\"margin-bottom:20px; height:400px; background-position:center; background-repeat:no-repeat; background-size:cover; background-image:url("+$(this).attr("src")+")\"></div>"+"<div class=\"lightbox_content\" key=\""+i+"\"><div>"+html+"</div><div><a class=\"modal_left\"><i class=\"fa fa-caret-left fa-3x\"></i></a><a class=\"modal_right\"><i class=\"fa fa-3x fa-caret-right\"></i></a></div></div>";

			}

			$(this).wrap("<a class='gallery' key='"+i+"' style='position:relative; display:block;' href='#'	data-featherlight='"+html+"' data-featherlight-type='html'>");
			$(this).before("<i class='fa fa-search-plus fa-2x' style='position:absolute; color:white; right:1rem; margin-left:0; top:1rem; margin-top:0;'></i>");
			
		} else {

		}
	});

	// console.log("LOADING ... 6");

	$("#body_left img[alt!=''][alt*='http']").each(function(i,o){

		var alt = $(this).attr("alt");

		if (alt == undefined) {
			return false;
		}

		var embed = alt.split("embed/")[1];

		var row = $(this).closest(".collection");

		var i = "";

		if ($(this).closest(".collection").length > 0) {
	i += $(this).closest(".collection").index(".collection");
	i += ":";
	i += $(this).closest(".collection").find(".column-xs-3 img").index($(this));
		} else {
	i += $(this).closest(".row").index(".row");
	i += ":";
	i += $(this).closest(".row").find(".column-xs-3 img").index($(this));
		}

		if ($(this).closest(".column-xs-3").length > 0) {

			var html = $(this).closest(".column").next(".column").html();
			var html = html.replace(/'/g, "&rsquo;");

			$(this).wrap("<div style='padding-bottom:100%;position:relative'></div>");
			$(this).attr("style", "height: 100% !important; width: 100% !important");
			$(this).css("object-fit", "cover");
			$(this).css("position", "absolute");
			$(this).attr("src", "https://i3.ytimg.com/vi/"+embed+"/mqdefault.jpg");

			var html = "<div style=\"margin-bottom:20px; height:400px;\"><iframe style=\"display:block; width:500px; height:400px;\" src=\""+alt+"\"></iframe></div>"+"<div class=\"lightbox_content\" key=\""+i+"\"><div>"+html+"</div><div><a class=\"modal_left\"><i class=\"fa fa-caret-left fa-3x\"></i></a><a class=\"modal_right\"><i class=\"fa fa-3x fa-caret-right\"></i></a></div></div>";

			$(this).wrap("<a class='gallery' key='"+i+"' style='position:absolute; display:block; width:100%; height:100%;' href='#' data-featherlight='"+html+"' data-featherlight-type='html'>");

		} else {

			var html = $(this).closest(".column").next(".column").html();

			if (html != undefined) {

				var html = html.replace(/'/g, "&rsquo;");

			}

			$(this).attr("src", "https://i3.ytimg.com/vi/"+embed+"/mqdefault.jpg");
			$(this).wrap("<div style='position:relative'></div>");

			var html = "<div style=\"margin-bottom:20px; height:400px;\"><iframe style=\"display:block; width:500px; height:400px;\" src=\""+alt+"\"></iframe></div>";

			$(this).wrap("<a class='' key='"+i+"' style='position:relative; display:block; width:100%; height:100%;' href='#' data-featherlight='"+html+"' data-featherlight-type='html'>");

		}

		if (embed == "9605BmDPpJk" || embed == "1HrDWNqrcYlw" || embed == "OkWzFAMOJSs") {
			//$(this).attr("src", "https://origin.agilitycms.com/mesca/aug2020/multizone2.jpg?w=640&h=360&c=3");
		}

		if (embed == "Q_72AAJNuQo") {
			//$(this).attr("src", "https://cdn.agilitycms.com/mesca/aug2020/video.jpg?w=640&h=360&c=3");
		}

		$(this).addClass("video");

		// $(this).wrap("<a style='position:absolute; display:block; width:100%; height:100%;' href='"+alt+"' data-featherlight='iframe' data-featherlight-iframe-width='640' data-featherlight-iframe-height='480' data-featherlight-iframe-frameborder='0' data-featherlight-iframe-allow='autoplay; encrypted-media' data-featherlight-iframe-allowfullscreen='true'>");
		$(this).before("<i class='fa fa-play-circle fa-3x' style='position:absolute; z-index:1; color:white; left:50%; margin-left:-1.5rem; top:50%; margin-top:-1.5rem;'></i>");

	});

	// $("a.gallery").each(function(i,o){

	// 	var row = $(this).closest(".row");

	// 	var index = row.index(".row");
	// 	var index2 = $(this).index("a.gallery");
		
	// 	$(this).attr("key", index+":"+index2);

	// });

	$(".column-xs-3 img[src*='dealer']").each(function(){

		$(this).closest("div").css("padding", "0")

	});


	$("img[src*='dealer']").each(function(){

		var src = $(this).attr("src")+"?w=350&h=300&c=3&q=60";
		$(this).attr("src", src);

		$(this).closest(".column").removeClass("column-xs-3").addClass("column-xs-2").css("padding", "0");
		$(this).closest(".column").css("padding", "0");
		$(this).closest(".column").next(".column-xs-8").removeClass("column-xs-8").addClass("column-xs-9").css("padding-left", "0");
		$(this).closest(".column").next(".column-xs-9").css("padding-left", "0");

	});


	$("img.modal").each(function(){
		if ($(this).attr("src").indexOf("indoor") > -1) {
			var src = $(this).attr("src")+"?w=500&h=500&c=2&q=60";
		} else {
			var src = $(this).attr("src")+"?w=500&h=500&c=3&q=60";
		}
		$(this).attr("src", src);

	});	
  }, [])
  

  return (
    <>
      <Head>
        <link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.15.1/css/all.css" integrity="sha384-9ZfPnbegQSumzaE7mks2IYgHoayLtuto3AS6ieArECeaR8nCfliJVuLh/GaQ1gyM" crossorigin="anonymous"></link>
        <link href="//cdn.jsdelivr.net/npm/featherlight@1.7.14/release/featherlight.min.css" type="text/css" rel="stylesheet" />
        <link href="//cdn.jsdelivr.net/npm/featherlight@1.7.14/release/featherlight.gallery.min.css" type="text/css" rel="stylesheet" />
        
      </Head>
	  <Script src="https://code.jquery.com/jquery-3.5.1.min.js" strategy="beforeInteractive"/>
	  <Script src="//cdn.jsdelivr.net/npm/featherlight@1.7.14/release/featherlight.min.js" strategy="lazyOnload"/>
      <Script src="//cdn.jsdelivr.net/npm/featherlight@1.7.14/release/featherlight.gallery.min.js" strategy="lazyOnload"/>
	  <Script src="https://frescoindustries.com/js/mesca-pre.js" strategy="lazyOnload"/>
      <div id="sidebar_fr" className={s.sidebarFR}>
        <p>
          <a className="button highlight" href="https://mitsubishielectric.ca/fr/hvac/where-to-buy" target="" rel="noopener">
            TROUVEZ UN CONCESSIONNAIRE
            <br/>
            <small>Il y en a un pr&#xE8;s de chez vous.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://mitsubishielectric.ca/fr/campaign/hvac-landing" target="" rel="noopener">
            RABAIS ET OFFRES
            <br/>
            <small>B&#xE9;n&#xE9;ficiez de rabais disponibles dans votre r&#xE9;gion.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://mitsubishielectric.ca/fr/hvac/MEQ_Warranty_Registration " target="" rel="noopener">
            ENREGISTREMENT DE LA GARANTIE PROLONG&#xC9;E
            <br/>
            <small>Ayez l'esprit tranquille gr&#226;ce &#xE0; notre garantie prolong&#xE9;e de 10 ans ou 12 ans.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://mitsubishielectric.ca/fr/hvac/home-owners/Financing" target="" rel="noopener">
            OFFRES DE FINANCEMENT
            <br/>
            <small>Nous ne nous contentons pas d&#x2019;ajouter du confort &#xE0; votre maison : nos solutions de paiement sont elles aussi plus confortables.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://mitsubishielectric.ca/fr/hvac/home-owners/faqs" target="" rel="noopener">
            FAQ
            <br/>
            <small>Voici des r&#xE9;ponses &#xE0; certaines des questions les plus fr&#xE9;quemment pos&#xE9;es en mati&#xE8;re de technologie de chauffage et de climatisation.</small>
          </a>
        </p>
        <p>
          <a className="button hvac_keepintouch" href="#" target="" rel="noopener">
            RESTONS EN CONTACT
            <br/>
            <small>Inscrivez-vous pour obtenir des conseils, de nouvelles offres et des d&#xE9;tails sur nos produits.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://www.mitsubishielectric.ca/fr/hvac/home-owners/articles" target="" rel="noopener">
            ARTICLES
            <br/>
            <small>Obtenez des conseils pour &#xE9;conomiser, pour assurer une bonne qualit&#xE9; de l&#x2019;air et plus encore.</small>
          </a>
        </p>
      </div>
      <div id="sidebar" className={s.sidebarBG}>
        <p>
          <a className="button highlight" href="https://mitsubishielectric.ca/en/hvac/where-to-buy" target="" rel="noopener">
            FIND A DEALER
            <br/>
            <small>There&rsquo;s one near you.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://mitsubishielectric.ca/en/campaign/hvac-landing" target="" rel="noopener">
            REBATES AND OFFERS
            <br/>
            <small>Take advantage of rebates in your area.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://mitsubishielectric.ca/en/hvac/MEQ_Warranty_Registration " target="" rel="noopener">
            EXTENDED WARRANTY REGISTRATION
            <br/>
            <small>Achieve peace of mind with our 10-year or 12-year extended warranty.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://mitsubishielectric.ca/en/hvac/home-owners/Financing" target="" rel="noopener">
            FINANCING OFFERS
            <br/>
            <small>We not only make your home comfortable, we can make paying for it more comfortable, too.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://mitsubishielectric.ca/en/hvac/home-owners/faqs" target="" rel="noopener">
            FAQs
            <br/>
            <small>Here are the answers to some commonly asked questions about heating and cooling technology.</small>
          </a>
        </p>
        <p>
          <a className="button hvac_keepintouch" href="#" target="" rel="noopener">
            LET&rsquo;S KEEP IN TOUCH
            <br/>
            <small>Sign up for tips, new offers and product details.</small>
          </a>
        </p>
        <p>
          <a className="button" href="https://www.mitsubishielectric.ca/en/hvac/home-owners/articles" target="" rel="noopener">
            ARTICLES
            <br/>
            <small>Get tips on how to save money, ensuring good air quality, and more.</small>
          </a>
        </p>
      </div>
    </>
  );
};

export default HomeOwners_Sidebar;

